import request from './request';

export const requestLogout = () =>
  request(`${import.meta.env.VITE_OUTVIO_API_URL}/logout`, { method: 'GET', secure: true });

export const requestUser = () =>
  request(`${import.meta.env.VITE_OUTVIO_API_URL}/customer/current-user`, {
    method: 'GET',
    secure: true,
  });

export const updateChangePassword = (data: { oldPassword: string; newPassword: string }) =>
  request(`${import.meta.env.VITE_OUTVIO_API_URL}/user/change-password`, {
    method: 'POST',
    data,
    secure: true,
  });

export const requestLoginWithEmail = (data: {
  email?: string;
  orderIdentifier?: string;
  clientIdentifier?: string;
  language: string;
}) =>
  request(`${import.meta.env.VITE_OUTVIO_API_URL}/identity-verification`, { method: 'POST', data });
